import { render, staticRenderFns } from "./SubmitDocumentsModal.vue?vue&type=template&id=a6b395a4&lang=pug&"
import script from "./SubmitDocumentsModal.vue?vue&type=script&lang=ts&"
export * from "./SubmitDocumentsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports